import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FREE_FORM_LESSON_UUID } from '../private-class-download-slides-link/private-class-download-slides-link.component';
import { PrivateClassFeedbackModalComponent } from '../private-class-feedback-modal/private-class-feedback-modal.component';
import { PrivateClassLesson } from '../private-class-lesson-dto';

@Component({
  selector: 'lp2-private-class-lesson-element',
  templateUrl: './private-class-lesson-element.component.html',
  styleUrls: ['./private-class-lesson-element.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivateClassLessonElementComponent {
  @Input() lesson: PrivateClassLesson;

  constructor(private readonly ngbModal: NgbModal) {}

  public get showFeedbackButton(): boolean {
    return this.lesson.lessonTaken && this.lesson.feedbackComplete;
  }

  public get lessonTaken(): boolean {
    return this.lesson.lessonTaken && !this.lesson.repeatingLesson;
  }

  public get showRepeatRecommend(): boolean {
    return this.lesson.lessonTaken && this.lesson.feedbackComplete && this.lesson.repeatingLesson;
  }

  public get isFreeFormTopic(): boolean {
    return this.lesson.uuid === FREE_FORM_LESSON_UUID;
  }

  public showFeedbackModal(event: Event) {
    event.preventDefault();
    const modalRef = this.ngbModal.open(PrivateClassFeedbackModalComponent, { size: 'lg' });
    modalRef.componentInstance.feedbackResponseId = this.lesson.feedbackResponseId;
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/private-class-banner/private-class-lesson-element/private-class-lesson-element.component.ts